export default __webpack_public_path__ + "static/blackbough-logo-7fed005dd503d9809ce1f3defc4d7c29.svg";